module.exports = __webpack_public_path__ + "01f43047/img/ion_calendar-number.3ac5bd07.svg";